import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every SPA route change.
// We set `send_page_view: false` in the base gtag config in index.html,
// so we control page_view firing here and avoid double-counting.
const usePageAnalytics = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        const id = typeof window !== "undefined" ? window.__GA4_ID__ : null;
        if (!id || typeof window.gtag !== "function") return;

        window.gtag("event", "page_view", {
            page_path: pathname + search,
            page_location: window.location.href,
            page_title: document.title,
            send_to: id,
        });
    }, [pathname, search]);
};

export default usePageAnalytics;
